import Container from "~/components/layout/Container";
import { slugify } from "~/lib/slugify";
import type { MekanikTesisatListesi } from "../mekanik-tesisatlar+/_index";


export default function MekanikTesisatlarComponent({ services }: { services: typeof MekanikTesisatListesi }) {
  return (
    <div className="py-20">
      <Container className="flex-wrap">
        <h1 className="text-3xl w-full justify-center font-black font-source-sans-pro text-center text-[32px] mb-5">Mekanik Tesisatlar</h1>
        <p className="flex w-full justify-center text-center font-extralight font-source-sans-pro not-italic mb-10 text-lg md:text-[24px] font-raleway text-[#444444]">
          Al-De Mühendislik, Modern Mekanik Çözümlerle Konforlu ve Güvenli Yaşam Alanları Sağlamak İçin Hizmetler Sunar.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {services.map((service) => (
            <a key={service.title} href={`/mekanik-tesisatlar/${slugify(service.title)}/${service.id}`} className="relative group mb-8">
              <img src={service.image} alt={service.title} width={600} height={400} loading="lazy" className="group-hover:shadow-lg w-full md:h-[400px] mix-blend-multiply object-cover" />
              <div className="p-2 relative bottom-0 left-0 w-full">
                <h3 className="md:text-base text-center font-raleway !text-lg text-[#16437c] !font-bold">{service.title}</h3>
                <p className="mt-2 text-base md:text-[14px] font-ibm-plex h-auto"
                  dangerouslySetInnerHTML={{ __html: service?.description?.replace(/<[^>]*>?/g, '')?.length > 180 ? `${service?.description?.replace(/<[^>]*>?/g, '')?.slice(0, 180)}...` : service?.description?.replace(/<[^>]*>?/g, '') }}
                />
              </div>
            </a>
          ))}
        </div>
      </Container>
    </div>
  );
};